module.exports = __webpack_public_path__ + "media/images/img-hobby-10-31b89a5b.jpg";